export const masterConfigurationList = [
  'dashboardConfig',
  'csvFileSizeLimitConfig',
  'templateConfigurations',
  'echoEndpoints',
  'deviceConfigurations'
];